<template>
<div >






<template v-if="loading">
<FrameOverlay></FrameOverlay>
</template>



<div class="mt-4" v-if="!loading" style="min-height:450px">


<div class="grid">

<!-- schedule_date-->
<div class="col-3 md:col-2">
<p class="click_edit_value_title">{{$store.state.languages.lang_phrases.oturum_tarihi}}:</p>
</div>

<div class="col-9 md:col-10">
<p class="click_edit_value">
{{data.verification.schedule_date}} - {{data.verification.schedule_time}}
</p>
</div>
<!-- schedule_date-->

<template v-if="the_date_match">
  

<!-- videocall_link-->
<div class="col-3 md:col-2">
<p class="click_edit_value_title">{{$store.state.languages.lang_phrases.video_konferans_linki}}:</p>
</div>

<div class="col-9 md:col-10 ">
  <template v-if="this.data.verification.videocall_link">
    <Button :label="$store.state.languages.lang_phrases.goruntule" class=" p-button-primary p-button-outlined  p-button-sm mt-3" :loading="$store.state.ui.submitting" @click="openVideoCallLink"></Button>
  </template>
  <template v-else>
    <p class="click_edit_value">Belirtilmemiş</p>
  </template>

</div>
<!-- videocall_link-->

<!-- videocall_link-->
<div class="col-3 md:col-2">
<p class="click_edit_value_title">{{$store.state.languages.lang_phrases.verification}}:</p>
</div>

<div class="col-9 md:col-10 ">
    <Button :label="$store.state.languages.lang_phrases.basla" class=" p-button-help   p-button-sm mt-3" :loading="$store.state.ui.submitting" @click="gotoVerification"></Button>
  

</div>
<!-- videocall_link-->



</template>





<!-- self_evaluation-->
<!--
<div class="col-3 md:col-2">
<p class="click_edit_value_title">{{$store.state.languages.lang_phrases.self_evaluation}}:</p>
</div>

<div class="col-9 md:col-10 ">
<Button :label="$store.state.languages.lang_phrases.goruntule" class=" p-button-primary p-button-outlined  p-button-sm mt-3" :loading="$store.state.ui.submitting" @click="openSelfEvaluation"></Button>
</div>
-->
<!-- self_evaluation-->

<!-- auditor_note-->
<template v-if="auditor_note">  

<div class="col-3 md:col-2">
<p class="click_edit_value_title">{{$store.state.languages.lang_phrases.denetciye_not}}:</p>
</div>

<div class="col-9 md:col-10">
<p class="click_edit_value" v-html="auditor_note">

</p>
</div>
</template>
<!-- auditor_note-->








</div>




</div>


</div>
</template>

<script>
import moment from "moment"
export default {

  name: 'AuditorVerificationSummary',

  data () {
    return {
    	loading:true,
      data:null,
      the_date_match:false,
    }
  },
  computed:{
    auditor_note()
    {
      if(this.data.verification.note_to_auditor)
      {
        let text = this.data.verification.note_to_auditor
        text = text.replaceAll("\r\n","<br/>")
        return text
      }
      else
      {
        return false
      }
    }
  },  
  mounted()
  {    
    this.getData()
  },
  methods:{   
   async gotoVerification()
   {
    let data = await this.generalApiGetWithoutLoader("start_verification/"+this.data.verification.flowsupplier.uuid)
    if(data=="done")
    {
      await this.$router.push({ name: 'Evaluation', params: { id:this.data.verification.flowsupplier.uuid } })
    }
    
   },
   openSelfEvaluation()
   {
      //this.$router.push({ name: 'Evaluation', params: { id:this.data.self_evaluation.uuid } })
      let api =  process.env.VUE_APP_APP_ROOT
      let user_uuid = this.$store.state.auth.user.uuid
      let flowsupplier_uuid = this.data.self_evaluation.uuid
      let url = api+"/"+user_uuid+"/evaluation/"+flowsupplier_uuid
      window.open(url, "_blank");
   },
   openVideoCallLink()
   {
      window.open(this.data.verification.videocall_link, "_blank");
   },
  	async getData()
    {
      
       this.loading = await true
       let data = await this.generalApiGetWithoutLoader("verification/show_auditor/"+this.$route.params.id)
      
       let today = moment().format("YYYY-MM-Do")
       console.log(data)
       if(moment().format("YYYY-MM-Do") == data.verification.schedule_date)
       {
          this.the_date_match = await true
       }
       if(moment().isSameOrAfter(data.verification.schedule_date) )
       {
          this.the_date_match = await true
       }
       

       this.data = await data
       this.loading = await false

    },   
  }
};
</script>

<style lang="css" scoped>
</style>